import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_CLIENT_ID,
    },
  },
};

if (!awsConfig.Auth.Cognito.userPoolId || !awsConfig.Auth.Cognito.userPoolClientId) {
  console.error(
    'Missing Cognito configuration. Ensure REACT_APP_USER_POOL_ID and REACT_APP_CLIENT_ID are set at build time.'
  );
}

Amplify.configure(awsConfig);

export default awsConfig;
